import { Component } from '@angular/core';

@Component({
  selector: 'app-gracias',
  templateUrl: './gracias.component.html',
  styleUrl: './gracias.component.css',
  standalone: false
})
export class GraciasComponent {

}
